import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { acceptFulfillmentOrderApi } from './acceptFulfillmentOrder.api'
import acceptFulfillmentOrderInitialState from './acceptFulfillmentOrder.initialState'
import {
  AcceptFulfillmentOrderErrorResponse,
  AcceptFulfillmentOrderRequest,
  AcceptFulfillmentOrderSuccessResponse
} from './acceptFulfillmentOrder.types'

export const acceptFulfillmentOrder = createAsyncThunk(
  urls.fulfillmentOrders.accept,
  async (
    {
      acceptFulfillmentOrderRequest,
      onSuccess
    }: {
      acceptFulfillmentOrderRequest: AcceptFulfillmentOrderRequest
      onSuccess: (data: AcceptFulfillmentOrderSuccessResponse) => void
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await acceptFulfillmentOrderApi(acceptFulfillmentOrderRequest)

      onSuccess(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const acceptFulfillmentOrderSlice = createSlice({
  name: urls.fulfillmentOrders.accept,
  initialState: acceptFulfillmentOrderInitialState,
  reducers: {
    resetAcceptFulfillmentOrder: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(acceptFulfillmentOrder.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(acceptFulfillmentOrder.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(acceptFulfillmentOrder.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as AcceptFulfillmentOrderErrorResponse
        state.success = null
      })
  }
})

export const { actions: acceptFulfillmentOrderActions, reducer: acceptFulfillmentOrderReducer } =
  acceptFulfillmentOrderSlice
export const { resetAcceptFulfillmentOrder } = acceptFulfillmentOrderActions
export default acceptFulfillmentOrderSlice.reducer
